import React, { useEffect } from 'react';
import Auth from '@Services/Auth';
import PropTypes from 'prop-types';
import RegisterForm from './Components/RegisterForm';
import LoginPageWrapper from '../Components/LoginPageWrapper';

import './Register.scss';

function Register(props) {
  const { init, isAnonymousUser, cancel, resetState } = props;
  const keyUpListener = (e) => {
    if (e && e.keyCode === 27 && isAnonymousUser) {
      cancel();
    }
  };

  useEffect(() => {
    if (isAnonymousUser === false && Auth.isReaxysAllowed()) {
      cancel();
      return;
    }
    init();
    document.addEventListener('keyup', keyUpListener);
    // eslint-disable-next-line consistent-return
    return () => {
      resetState();
      document.removeEventListener('keyup', keyUpListener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LoginPageWrapper className="react-page-register-page">
      <RegisterForm {...props} isUsernameVisible />
    </LoginPageWrapper>
  );
}

Register.propTypes = {
  init: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  isAnonymousUser: PropTypes.bool,
  resetState: PropTypes.func.isRequired,
};

export default Register;
